import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { ActivityLog } from "@idw-types/data/reports";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type GetActivityLogsRequestResponse = {
    activityLogs: Array<ActivityLog>;
};

export const getActivityLogsRequest = async (
    userID: string,
    companyId: string,
    startDate: string,
    endDate: string,
    timeZone: string
): Promise<GenericNetworkResponse<GetActivityLogsRequestResponse>> => {
    const route = apiRoutes.reports.activityLogs;
    const queryParameters: Array<QueryParameter> = [];

    if (userID) {
        queryParameters.push({ parameter: "userID", value: userID });
    }
    if (companyId) {
        queryParameters.push({ parameter: "organizationID", value: companyId });
    }
    if (startDate) {
        queryParameters.push({ parameter: "startDate", value: startDate });
    }
    if (endDate) {
        queryParameters.push({ parameter: "endDate", value: endDate });
    }
    if (timeZone) {
        queryParameters.push({ parameter: "timeZone", value: timeZone });
    }

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};
